import fundQuotaLogic from './containers/QuotaHistoryTable/fundQuota/middleware';
import exportQuotaLogic from './containers/QuotaHistoryTable/exportQuota/middleware';
import exportPortfolioLogic from './containers/PortfolioCompositionTable/exportPortfolio/middleware';
import portfolioCompositionLogic from './containers/PortfolioCompositionTable/portfolioComposition/middleware';

export default [
  fundQuotaLogic,
  exportQuotaLogic,
  exportPortfolioLogic,
  portfolioCompositionLogic,
];
